ScoreTrekBattle.Tournament.Ranking = (function() {
    var _this, STATUS, MAP;

    function resetStatus(context) {
        STATUS = STATUS || {
            render: {},
            editor: {}
        };
        STATUS[context] = {
            $view: null,
            tournament: null,
            teams: null,
            group: null,
            dialog: null,
            dragging: false,
            allowHighlight: false,
            resolve: () => {},
            reject: () => {}
        };
    }
    resetStatus('render');
    resetStatus('editor');

    function resetMap(context) {
        MAP = MAP || {
            render: {},
            editor: {}
        };

        MAP[context] = {
            TEAMS: {}
        };
    }
    resetMap('render');
    resetMap('editor');

    function updateMap(context) {
        MAP[context].TEAMS = {};

        if (STATUS[context].teams) {
            MAP[context].TEAMS = STATUS[context].teams;
            return;
        }

        if (STATUS[context].group && STATUS[context].group.teams) {
            STATUS[context].group.teams.forEach(team => {
                MAP[context].TEAMS[team.id] = team;
            });
        }
    }

    function loadGroup(groupId) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Ranking.loadGroup', true);
            Api.request('/battle/tournament/group', {groupId: groupId}).then(result => {
                if (result && result.group) {
                    resolve(result.group);
                } else {
                    reject();
                }
            }).catch(error => {
                reject(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Ranking.loadGroup', false);
            });
        });
    }

    function hasPositionTo(tournament) {
        return (tournament.preset && tournament.preset.preset && (['no', 'split'].indexOf(tournament.preset.preset.koSystem) < 0));
    }

    function renderRankings(context, rankings, qualificantsCount, showPositionTo) {
        return new Promise(function(resolve) {
            var rankingItems, rankingPromises, qualified, currentPosition, equalRankingItems, equalOffset;

            if (rankings === null) {
                resolve(null);
                return;
            }

            rankingPromises = [];
            rankingPromises.push(renderRankingHeader());

            qualified = [];
            currentPosition = -2;
            equalRankingItems = {};
            rankingItems = [];

            rankings.forEach(ranking => {
                let rankingKey, rankingItem;

                rankingKey = `${ranking.position}_${ranking.partition}`;

                if (ranking.position !== currentPosition) {
                    currentPosition = ranking.position;
                    qualified.push([]);
                }
                qualified[qualified.length - 1].push(ranking);

                rankingItem = {
                    context: context,
                    ranking: ranking,
                    position: ranking.position,
                    partition: ranking.partition,
                    positionTo: 0
                };

                rankingItems.push(rankingItem);

                if (!equalRankingItems.hasOwnProperty(rankingKey)) {
                    equalRankingItems[rankingKey] = [];
                }

                equalRankingItems[rankingKey].push(rankingItem);
            });

            if (showPositionTo) {
                equalOffset = 0;
                
                Object.values(equalRankingItems).forEach(rankingItems => {
                    let equalCount;

                    equalCount = rankingItems.length;

                    if (equalCount > 1) {
                        rankingItems.forEach(rankingItem => {
                            rankingItem.positionTo = rankingItem.position + equalCount - 1;
                        });
                        equalOffset += equalCount;
                    }

                });
            }

            rankingItems.forEach(rankingItem => {
                rankingPromises.push(renderRanking(rankingItem.context, rankingItem.ranking, rankingItem.partition, rankingItem.position, rankingItem.positionTo));
            });


            Promise.all(rankingPromises).then($rankings => {
                var qualifiedCurrent, qualificantsTotal, isValid;

                if (qualificantsCount > 0) {
                    qualificantsTotal = 0;

                    while(qualified.length > 0) {
                        qualifiedCurrent = qualified.shift();

                        qualificantsTotal += qualifiedCurrent.length;

                        isValid = (qualificantsTotal <= qualificantsCount);

                        markRankingsAsQualified($rankings, qualifiedCurrent, isValid ? 'yes' : 'conflict');

                        if (qualificantsTotal >= qualificantsCount) {
                            break;
                        }
                    }
                } else {
                    $rankings.forEach($ranking => {
                        $ranking.attr('data-is-qualified', '');
                    });
                }

                resolve($rankings);
            });
        });
    }

    function markRankingsAsQualified($rankings, qualifiedRankings, isQualifiedString) {
        qualifiedRankings.forEach(ranking => {
            $rankings.find($ranking => ($ranking.attr('data-ranking-id') === ranking.id)).attr('data-is-qualified', isQualifiedString);
        });
    }

    function renderRankingHeader() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/live/rankingHeader').then(view => {
                resolve(view.$view);
            });
        });
    }

    function renderRanking(context, ranking, partition, position, positionTo) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/live/ranking').then(view => {
                renderRankingData(context, ranking, partition, positionTo, view.$view).then(() => {
                    view.$view.attr({
                        'data-ranking-id': ranking.id,
                        'data-team-id': ranking.teamId,
                        'data-position': position,
                        'data-partition': partition,
                        'data-is-qualified': 'no'
                    });
                    resolve(view.$view);
                });
            });
        });
    }

    function renderRankingData(context, ranking, partition, positionTo, $ranking) {
        return new Promise(function(resolve) {
            var team;

            team = MAP[context].TEAMS[ranking.teamId];

            if (!team) {
                resolve(renderTeamError());
                return;
            }

            renderTeam(context, team).then($team => {
                let trophy, isMulti, isSplit;

                isMulti = (positionTo > ranking.position);
                isSplit = ((positionTo - ranking.position) === 1);

                $ranking.find(`[data-id="team"]`).empty().append($team);

                if (team.participants.length < 2) {
                    $ranking.find('[data-ref-id="team"]').hide();
                }

                $ranking.find(`[data-id="position"]`).html(
                    (ranking.position === -1)
                        ? '<span style="color:var(--color-white-30);"><i class="fa-solid fa-ban"></i></span>'
                        : (
                            (ranking.position === 0)
                                ? '<i class="fa-regular fa-clock"></i></span>'
                                : `<span class="text-no-wrap">${ranking.partition ? `${ranking.partition} ` : ''}${ranking.position}</span>${(isMulti && !isSplit) ? `<span style="opacity:0.3;">–<span class="text-no-wrap">${positionTo}</span></span>` : ''}`)
                );

                trophy = (ranking.position === -1)
                    ? '<i class="fa-solid fa-medal"></i>'
                    : (
                        ([1,2,3].indexOf(ranking.position) >= 0)
                            ? '<i class="fa-solid fa-trophy"></i>'
                            : '<i class="fa-solid fa-medal"></i>'
                    )
                ;

                $ranking.find(`[data-id="trophy"]`).attr('data-position', ranking.position).empty().append(trophy);

                ['gamesPlayed', 'gamesWon', 'gamesTied', 'gamesLost', 'pointsWonText', 'pointsLostText', 'pointsDiffText'].forEach(rankingKey => {
                    $ranking.find(`[data-id="${rankingKey}"]`).text(`${ranking[rankingKey]}`);
                });

                resolve($ranking);
            });
        });
    }

    function renderTeam(context, team) {
        return new Promise(function(resolve) {
            var isDouble, options;

            // TODO check if team size works here
            isDouble = (STATUS[context].tournament.preset.teamSize > 1);

            options = {
                teamSize: isDouble ? 2 : 1,
                toggle: isDouble ? 'closed' : 'disabled',
                allowHighlight: STATUS[context].allowHighlight ? 'yes' : 'no',
                playerClickable: (context === 'render')
            };

            ScoreTrekBattle.Tournament.Match.renderTeam(
                STATUS[context].$view,
                team,
                options
            ).then($team => {
                resolve($team);
            }).catch(error => {
                console.error(error);
                resolve(renderTeamError());
            });
        });
    }

    function renderTeamError() {
        return `<span class="color-light-pink"><i class="fa-solid fa-triangle-exclamation"></i> ${__i18n('tournament/team/none')}</span>`;
    }

    function renderRankingEditor(context) {
        ScoreTrekBattle.Template.render('tournament/edit/groupRanking', {
            tournament: STATUS[context].tournament,
            group: STATUS[context].group
        }).then(view => {
            STATUS[context].$view = view.$view;

            renderRankings(context, STATUS[context].group.ranking, STATUS[context].group.qualificantsCount, hasPositionTo(STATUS[context].tournament)).then($rankings => {
                var $allRankings, $rankingsHeader, $qualificants;

                $rankingsHeader = $rankings.shift();

                $qualificants = [];

                $allRankings = STATUS[context].$view.find('[data-id="rankings"]');
                $allRankings.empty();

                while (($rankings.length > 0) && ($rankings[0].attr('data-is-qualified') === 'yes')) {
                    $qualificants.push($rankings.shift());
                }

                $qualificants.forEach($qualificant => {
                    $allRankings.append($qualificant.clone());
                });

                while($qualificants.length < STATUS[context].group.qualificantsCount) {
                    $qualificants.push(renderRankingDropTarget());
                }

                STATUS[context].$view.find('[data-id="rankingsHeader"]').empty().append($rankingsHeader);
                STATUS[context].$view.find('[data-id="qualificants"]').empty().append($qualificants);
                $allRankings.append($rankings);

                enableDragDrop(context);
            });

            STATUS[context].dialog = chmDialog({
                title: __i18n('tournament/ranking/edit/dialog/title', {groupName: __i18n('game/group', {group: STATUS[context].group.number})}),
                content: view.$view,
                large: true,
                centerButtons: true,
                paddingTop: false,
                buttons: [
                    {
                        label: __i18n('button/save'),
                        icon: '<i class="fa-solid fa-check"></i>',
                        primary: true,
                        action: () => {
                            saveRankings(context);
                            return false;
                        }
                    },
                    {
                        label: __i18n('button/cancel'),
                        secondary: true,
                        action: () => {
                            STATUS[context].reject();
                        }
                    }
                ],
                onShow: () => {
                }
            });
        });
    }

    function closeDialog(context) {
        if (!STATUS[context].dialog) {
            return;
        }

        STATUS[context].dialog.close();
        STATUS[context].dialog = null;
    }

    function saveRankings(context) {
        var qualificantsExpected, $qualificantsAssigned, qualificantIds;

        if (!STATUS[context].$view) {
            return;
        }

        qualificantsExpected = STATUS[context].$view.find('[data-id="qualificants"] [data-id="dropTarget"]').length;
        $qualificantsAssigned = STATUS[context].$view.find('[data-id="qualificants"] [data-ranking-id]');

        if (qualificantsExpected > $qualificantsAssigned.length) {
            chmDialog.warning(__i18n('error/QUALIFICANTS_COUNT_INVALID'), __i18n('tournament/ranking/edit/dialog/warning'), __i18n('button/gotIt'));
            return;
        }

        qualificantIds = [];
        $qualificantsAssigned.each(function() {
            qualificantIds.push(this.dataset.rankingId);
        });

        persistRankings(context, qualificantIds).then(affectedGames => {
            STATUS[context].resolve(affectedGames);
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function persistRankings(context, qualificantIds) {
        return new Promise(function(resolve, reject) {
            if (!STATUS[context].group) {
                reject({message: 'GROUP_DOES_NOT_EXIST'});
                return;
            }

            ScoreTrekBattle.View.loading('Tournament.Ranking.persistRankings', true);
            Api.request('/battle/tournament/ranking/set', {
                groupId: STATUS[context].group.id,
                qualificantIds: qualificantIds
            }).then(result => {
                if (result && result.affectedGames) {
                    resolve(result.affectedGames);
                } else {
                    reject({message: 'PERSIST_FAILED'});
                }
            }).catch(error => {
                reject(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Ranking.persistRankings', false);
            });
        });
    }

    function validateResetRankings(context) {
        return new Promise(function(resolve, reject) {
            if (!STATUS[context].group) {
                reject({message: 'GROUP_DOES_NOT_EXIST'});
                return;
            }

            ScoreTrekBattle.View.loading('Tournament.Ranking.validateResetRankings', true);
            Api.request('/battle/tournament/ranking/validate/reset', {
                groupId: STATUS[context].group.id
            }).then(result => {
                if (result && result.affectedGames) {
                    confirmAffectedGames(result.affectedGames).then(resolve).catch(reject);
                } else {
                    reject({message: 'INVALID_INPUT'});
                }
            }).catch(error => {
                reject(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Ranking.validateResetRankings', false);
            });
        });
    }

    function confirmAffectedGames(affectedGames) {
        return new Promise(function(resolve, reject) {
            var matchNames;

            matchNames = Object.values(affectedGames).map(game => {
                return game.number;
            });

            if (matchNames.length <= 1) {
                resolve();
                return;
            }

            matchNames.sort(function(a, b) {
                return a - b;
            });

            matchNames = matchNames.map(gameNumber => {
                return __i18n('game/name', {number: gameNumber});
            });

            chmDialog.confirm(__i18n('dialog/confirm/affectedMatches/text', {matchNames: `<span class="text-no-wrap">${matchNames.join('</span><span class="color-white">,</span> <span class="text-no-wrap">')}</span>`}), {
                title: __i18n('dialog/confirm/affectedMatches/title'),
                buttonYes: __i18n('button/continue'),
                buttonNo: __i18n('button/cancel')
            }).then(resolve).catch(reject);
        });
    }

    function resetRankings(context) {
        if (!STATUS[context].group) {
            STATUS[context].reject({message: 'GROUP_DOES_NOT_EXIST'});
            return;
        }

        ScoreTrekBattle.View.loading('Tournament.Ranking.resetRankings', true);
        Api.request('/battle/tournament/ranking/reset', {
            groupId: STATUS[context].group.id
        }).then(result => {
            if (result && result.affectedGames) {
                STATUS[context].resolve(result.affectedGames);
            } else {
                STATUS[context].reject({message: 'RESET_FAILED'});
            }
        }).catch(error => {
            STATUS[context].reject(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Ranking.resetRankings', false);
        });
    }

    function renderRankingDropTarget() {
        return `<div class="ranking-editor-drop-target" data-id="dropTarget"><div class="ranking-editor-drop-target-info"><i class="fa-solid fa-arrow-right"></i> ${__i18n('tournament/ranking/edit/dropTarget')} <i class="fa-solid fa-arrow-left"></i></div></div>`;
    }

    function enableDragDrop(context) {
        var $scrollable;

        $scrollable = STATUS[context].$view.closest('.dialog');

        STATUS[context].$view.find('[data-is-qualified="conflict"]').draggable({
            revert: 'invalid',
            start: function(event, ui) {
                var $this, offsetTop;

                STATUS[context].dragging = true;

                $this = $(this);
                this.classList.add('isDragged');
                STATUS[context].$view.find('[data-is-qualified="conflict"]').css('z-index', '');
                this.style.zIndex = 999999;

                STATUS[context].$view.find('.ranking-editor-ranking').css('z-index', 999999);

                offsetTop = ($this.offset().top - $scrollable.offset().top);
                $scrollable.attr({
                    'data-min-top': (1 - offsetTop - $scrollable.scrollTop()),
                    'data-max-top': ($scrollable.get(0).scrollHeight - $scrollable.scrollTop() - offsetTop - this.offsetHeight),
                    'data-scroll-top': $scrollable.scrollTop()
                });
            },
            drag: function(event, ui) {
                var minTop, maxTop, justifiedTop, initialScrollTop;

                minTop = parseInt($scrollable.attr('data-min-top'), 10);
                maxTop = parseInt($scrollable.attr('data-max-top'), 10);

                initialScrollTop = parseInt($scrollable.attr('data-scroll-top'), 10);
                justifiedTop = (ui.position.top - $scrollable.scrollTop() + initialScrollTop);

                ui.position.top = Math.max(minTop, Math.min(maxTop, justifiedTop));
            },
            stop: function(event, ui) {
                this.classList.remove('isDragged');
                this.style.zIndex = '';

                STATUS[context].dragging = false;

                STATUS[context].$view.find('.ranking-editor-ranking').css('z-index', '');
            }
        });

        STATUS[context].$view.find('[data-id="dropTarget"]').droppable({
            accept: '[data-is-qualified="conflict"]',
            over: function(event, ui) {
                var $draggable;
                $draggable = ui.draggable;

                this.classList.add('allowDrop');
            },
            out: function(event, ui) {
                this.classList.remove('allowDrop');
            },
            drop: function(event, ui) {
                var $draggable, $draggableClone, $this, rankingIds, position;
                $draggable = ui.draggable;

                this.classList.remove('allowDrop');

                $this = $(this);

                rankingIds = [];
                rankingIds.push($draggable.attr('data-ranking-id'));

                $this.find('[data-is-qualified="conflict"]').each(function() {
                    rankingIds.push(this.dataset.rankingId);
                });

                rankingIds.forEach(rankingId => {
                    STATUS[context].$view.find(`[data-ranking-id="${rankingId}"]`).removeClass('isDropped');
                    STATUS[context].$view.find(`[data-id="qualificants"] [data-ranking-id="${rankingId}"]`).remove();
                });

                $draggable.attr('style', '').removeClass('isDragged').addClass('isDropped');

                $draggableClone = $draggable.clone();

                position = $this.index() + 1;
                $draggableClone.find('[data-id="position"]').html(`<span class="text-green">${position}.</span>`);

                $this.append($draggableClone);

                updateHasParticipant(context);
            }
        });
    }

    function updateHasParticipant(context) {
        STATUS[context].$view.find('[data-id="dropTarget"]').each(function() {
            this.classList.toggle('hasParticipant', this.querySelector('[data-is-qualified="conflict"]') !== null);
        });
    }

    _this = {
        render: function($view, tournament, teams, rankings, qualificantsCount) {
            var context;

            context = 'render';
            resetStatus(context);
            resetMap(context);

            STATUS[context].tournament = tournament;
            STATUS[context].teams = teams;
            STATUS[context].allowHighlight = true;
            STATUS[context].$view = $view;

            updateMap(context);

            return renderRankings(context, rankings, qualificantsCount, hasPositionTo(tournament));
        },

        editGroupQualificants: function(tournament, groupId) {
            return new Promise(function(resolve, reject) {
                var context;

                context = 'editor';
                resetStatus(context);
                resetMap(context);

                STATUS[context].tournament = tournament;
                STATUS[context].resolve = (result) => {
                    closeDialog('editor');
                    resolve(result);
                };
                STATUS[context].reject = (error) => {
                    closeDialog('editor');
                    reject(error);
                };

                loadGroup(groupId).then(group => {
                    STATUS[context].group = group;
                    updateMap('editor');
                    renderRankingEditor('editor');
                }).catch(error => {
                    reject(error || {message: 'GROUP_DOES_NOT_EXIST'});
                });
            });
        },

        resetGroupQualificants: function(tournament, groupId) {
            return new Promise(function(resolve, reject) {
                var context;

                context = 'editor';
                resetStatus(context);
                resetMap(context);

                STATUS[context].tournament = tournament;
                STATUS[context].resolve = resolve;
                STATUS[context].reject = reject;

                loadGroup(groupId).then(group => {
                    STATUS[context].group = group;

                    chmDialog.confirm(__i18n('dialog/confirm/resetRankings/text', {reference: __i18n('game/group', {group: STATUS[context].group.number})}, true), {
                        title: __i18n('dialog/confirm/resetRankings/title'),
                        buttonYes: __i18n('button/resetQualification'),
                        buttonNo: __i18n('button/cancel')
                    }).then(() => {
                        validateResetRankings('editor').then(() => {
                            resetRankings('editor');
                        }).catch(error => {
                            reject(error);
                        });
                    }).catch(() => {
                        reject();
                    });

                }).catch(error => {
                    reject(error || {message: 'GROUP_DOES_NOT_EXIST'});
                });
            });
        }
    };

    return _this;
})();